import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { cmsApiConfig } from '../../cmsConfig';
import { Activity } from '../../types/Activity/Activity';
import { ActivityTexts } from '../../types/Activity/ActivityTexts';

const sanitizeActivityPayload = (activity: Activity): Activity => {
  return {
    ...activity,
    modifiedBy: activity.modifiedBy || undefined,
    activityId: activity.activityId || undefined,
  };
};

export const activityApi = createApi({
  reducerPath: 'activityApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${cmsApiConfig.url}/portalapi/activities`,
    headers: {
      'X-CSRF': '1',
    },
    credentials: 'include',
  }),
  tagTypes: ['Activities', 'Texts'],
  endpoints: (builder) => ({
    getPageTexts: builder.query<ActivityTexts, void>({
      query: () => ({
        url: '/getPageTexts',
        method: 'GET',
      }),
      providesTags: ['Texts'],
    }),
    getAllActivities: builder.query<Activity[], string>({
      query: (id) => ({
        url: `?participantId=${id}`,
        method: 'GET',
      }),
      providesTags: ['Activities'],
    }),
    AddActivity: builder.mutation<
      void,
      { activity: Activity; participantId: string }
    >({
      query: ({ activity, participantId }) => ({
        url: `?participantId=${participantId}`,
        method: 'POST',
        body: sanitizeActivityPayload(activity),
      }),
      invalidatesTags: ['Activities'],
    }),
    editActivity: builder.mutation<void, Activity>({
      query: (activity) => ({
        url: ``,
        method: 'PUT',
        body: sanitizeActivityPayload(activity),
      }),
      invalidatesTags: ['Activities'],
    }),
    deleteActivity: builder.mutation<void, string>({
      query: (activityId) => ({
        url: `/${activityId}`,
        method: 'PUT',
      }),
      invalidatesTags: ['Activities'],
    }),
  }),
});

export const {
  useLazyGetPageTextsQuery,
  useLazyGetAllActivitiesQuery,
  useAddActivityMutation,
  useEditActivityMutation,
  useDeleteActivityMutation,
} = activityApi;
